export enum EProjectStatus {
    /// <summary>
    /// 取消
    /// </summary>
    Canceled = 0,

    /// <summary>
    /// 创建(暂存保存)
    /// </summary>
    Created = 10,

    /// <summary>
    /// 下发
    /// </summary>
    Sent = 20,

    /// <summary>
    /// 项目审核
    /// </summary>
    ProjectExamining = 30,

    /// <summary>
    /// 项目审核通过
    /// </summary>
    ProjectPassed = 40,

    /// <summary>
    /// 接收
    /// </summary>
    Received = 50,

    /// <summary>
    /// 转办待接收
    /// </summary>
    TurnToDo = 51,

    /// <summary>
    /// 转办已接收
    /// </summary>
    TurnToDoReceived = 52,

    /// <summary>
    /// 延期审核中
    /// </summary>
    DelayExaming = 53,

    /// <summary>
    /// 取消审核中
    /// </summary>
    CancelExaming = 54,

    /// <summary>
    /// 提交
    /// </summary>
    Submitted = 60,

    /// <summary>
    /// 回执审核中
    /// </summary>
    ReceiptExamining = 70,

    /// <summary>
    /// 结束
    /// </summary>
    Completed = 80,

    /// <summary>
    /// 项目变更创建
    /// </summary>
    Change = 100,

    /// <summary>
    /// 变更中
    /// </summary>
    Changing = 110,

    /// <summary>
    /// 变更完成
    /// </summary>
    Changed = 120
}